// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

import type { PartialDeep } from 'type-fest';

import type { ExcludeMethodsDeep } from '../../../utils/types';
import { NIL_UUID } from '../../../utils/uuid';
import {
  type CustomFieldOptions,
  type CustomFieldOptionsWireFormat,
  NewCustomFieldOptions,
} from '../CustomFieldOptions/CustomFieldOptions';
import Enums from '../Enums';

export class CustomFieldDefinition {
  readonly id: string;
  readonly name: string;
  readonly priority: number;
  readonly type: Enums.CustomFieldType;
  readonly options: CustomFieldOptions[] | null;
  readonly domainType: string;
  readonly isRequired: boolean;
  readonly defaultValue: string | null;

  constructor(data: { [key: string]: any } = {}) {
    this.id = data.id === undefined ? NIL_UUID : data.id;
    this.name = data.name === undefined ? '' : data.name;
    this.priority = data.priority === undefined ? 0 : data.priority;
    this.type = data.type === undefined ? Enums.CustomFieldType.String : data.type;
    this.options =
      // eslint-disable-next-line no-nested-ternary
      (data.options ?? null) === null
        ? null
        : (data.options ?? []).map((options: any) => NewCustomFieldOptions(options));
    this.domainType = data.domainType === undefined ? '' : data.domainType;
    this.isRequired = data.isRequired === undefined ? false : data.isRequired;
    this.defaultValue = data.defaultValue === undefined ? null : data.defaultValue;
  }

  static zero(): CustomFieldDefinition {
    const zeroValues: ExcludeMethodsDeep<CustomFieldDefinition> = {
      id: NIL_UUID,
      name: '',
      priority: 0,
      type: Enums.CustomFieldType.String,
      options: null,
      domainType: '',
      isRequired: false,
      defaultValue: null,
    };
    return new CustomFieldDefinition(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************

  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type CustomFieldDefinitionWireFormat = {
  id: string;
  name: string;
  priority: number;
  type: string;
  options: CustomFieldOptionsWireFormat[] | null;
  domainType: string;
  isRequired: boolean;
  defaultValue: string | null;
};

type NewCustomFieldDefinitionProps = PartialDeep<
  CustomFieldDefinition,
  { recurseIntoArrays: true }
>;
export const NewCustomFieldDefinition: (
  props: NewCustomFieldDefinitionProps,
) => CustomFieldDefinition = (props) => new CustomFieldDefinition(props);

type NewCustomFieldDefinitionFromWireFormatProps = PartialDeep<
  CustomFieldDefinitionWireFormat,
  { recurseIntoArrays: true }
>;
export const NewCustomFieldDefinitionFromWireFormat: (
  props: NewCustomFieldDefinitionFromWireFormatProps,
) => CustomFieldDefinition = (props) => new CustomFieldDefinition(props);
